// // src/pages/account/DeleteAccount.jsx
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import { 
//   FaArrowLeft, 
//   FaTrash, 
//   FaExclamationTriangle,
//   FaEye,
//   FaEyeSlash,
//   FaSpinner,
//   FaUser,
//   FaShieldAlt,
//   FaCheckCircle,
//   FaTimes,
//   FaStar,
//   FaClock,
//   FaBan
// } from 'react-icons/fa';
// import Nav from '../../../components/layout/Nav';
// import { serverUrlAuth } from '../../../serverUrl';
// import './DeleteAccount.scss';

// const DeleteAccount = () => {
//   const navigate = useNavigate();
  
//   const [user, setUser] = useState(null);
//   const [password, setPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [showConfirmDialog, setShowConfirmDialog] = useState(false);
//   const [error, setError] = useState('');
//   const [isPasswordFocused, setIsPasswordFocused] = useState(false);
//   const [confirmText, setConfirmText] = useState('');

//   // Load user from localStorage on mount
//   useEffect(() => {
//     const token = localStorage.getItem('access_token');
//     const role = localStorage.getItem('role');
//     const fullName = localStorage.getItem('full_name');
//     const email = localStorage.getItem('email');

//     if (token && role) {
//       setUser({
//         role: role,
//         full_name: fullName || '',
//         email: email || '',
//       });
//     } else {
//       navigate('/login');
//     }
//   }, [navigate]);

//   // Check if user is admin and redirect
//   useEffect(() => {
//     if (user?.role === 'admin') {
//       navigate('/admin-dashboard');
//       toast.error('Administrator accounts cannot be deleted');
//     }
//   }, [user, navigate]);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setError('');

//     if (!password.trim()) {
//       setError('Password is required');
//       return;
//     }

//     setConfirmText('');
//     setShowConfirmDialog(true);
//   };

//   const handleConfirmDelete = async () => {
//     setIsLoading(true);
//     setError('');

//     try {
//       const response = await serverUrlAuth.delete('users/delete-account/', {
//         data: { password }
//       });

//       if (response.status === 200) {
//         toast.success('Account deleted successfully');
        
//         try {
//           const token = localStorage.getItem('fcm_token');
//           if (token) {
//             await serverUrlAuth.post('/notifications/remove-push-token/', {
//               token,
//             });
//           }
//         } catch (fcmError) {
//           console.error('Error removing FCM token:', fcmError);
//         }

//         localStorage.clear();
//         navigate('/');
//       }
//     } catch (err) {
//       const errorMessage = err.response?.data?.error || 'Failed to delete account';
//       setError(errorMessage);
//       toast.error(errorMessage);
//       setShowConfirmDialog(false);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleCancelDelete = () => {
//     setShowConfirmDialog(false);
//     setConfirmText('');
//     setError('');
//   };

//   const handleBack = () => {
//     navigate(-1);
//   };

//   // Close modal on Escape key
//   useEffect(() => {
//     const handleEsc = (e) => {
//       if (e.key === 'Escape' && showConfirmDialog) {
//         handleCancelDelete();
//       }
//     };
//     window.addEventListener('keydown', handleEsc);
//     return () => window.removeEventListener('keydown', handleEsc);
//   }, [showConfirmDialog]);

//   // Prevent body scroll when modal is open
//   useEffect(() => {
//     if (showConfirmDialog) {
//       document.body.style.overflow = 'hidden';
//     } else {
//       document.body.style.overflow = 'unset';
//     }
//     return () => {
//       document.body.style.overflow = 'unset';
//     };
//   }, [showConfirmDialog]);

//   if (!user) {
//     return (
//       <Nav>
//         <div className="delete-account-page">
//           <div className="container">
//             <div className="loading-state">
//               <FaSpinner className="spinner-large" />
//               <p>Loading...</p>
//             </div>
//           </div>
//         </div>
//       </Nav>
//     );
//   }

//   return (
//     <>
//       <Nav />
//       <div className="delete-account-page">
//         <div className="container">
//           <button className="back-button" onClick={handleBack}>
//             <FaArrowLeft />
//             <span>Back to Profile</span>
//           </button>

//           <div className="delete-card">
//             <div className="delete-card-header">
//               <div className="icon-wrapper">
//                 <FaTrash />
//               </div>
//               <div>
//                 <h1>Delete Account</h1>
//                 <p>This action is permanent and cannot be undone</p>
//               </div>
//             </div>

//             <div className="delete-card-body">
//               <div className="alert alert-danger">
//                 <FaExclamationTriangle className="alert-icon" />
//                 <div>
//                   <h4>Warning</h4>
//                   <p>
//                     Deleting your account will permanently remove all your personal information.
//                     Your transaction history, reviews, and ratings will be anonymized but retained
//                     for operational and compliance purposes.
//                   </p>
//                 </div>
//               </div>

//               {error && (
//                 <div className="alert alert-error">
//                   <FaExclamationTriangle className="alert-icon" />
//                   <div>
//                     <h4>Error</h4>
//                     <p>{error}</p>
//                   </div>
//                 </div>
//               )}

//               <div className="account-summary">
//                 <div className="summary-item">
//                   <div className="summary-icon">
//                     <FaUser />
//                   </div>
//                   <div>
//                     <span className="label">Full Name</span>
//                     <span className="value">{user?.full_name || 'N/A'}</span>
//                   </div>
//                 </div>
//                 <div className="summary-item">
//                   <div className="summary-icon">
//                     <FaShieldAlt />
//                   </div>
//                   <div>
//                     <span className="label">Role</span>
//                     <span className="value role-badge">{user?.role || 'N/A'}</span>
//                   </div>
//                 </div>
//                 <div className="summary-item">
//                   <div className="summary-icon">
//                     <FaCheckCircle />
//                   </div>
//                   <div>
//                     <span className="label">Account Status</span>
//                     <span className="value status-badge active">Active</span>
//                   </div>
//                 </div>
//               </div>

//               <div className="delete-form-wrapper">
//                 <div className="form-header">
//                   <h3>Confirm Your Identity</h3>
//                   <p>Enter your current password to proceed with account deletion</p>
//                 </div>

//                 <form onSubmit={handleSubmit} className="delete-form">
//                   <div className="form-group">
//                     <label htmlFor="password">Current Password</label>
//                     <div className={`password-input-wrapper ${isPasswordFocused ? 'focused' : ''} ${error ? 'error' : ''}`}>
//                       <input
//                         id="password"
//                         type={showPassword ? 'text' : 'password'}
//                         placeholder="Enter your current password"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                         onFocus={() => setIsPasswordFocused(true)}
//                         onBlur={() => setIsPasswordFocused(false)}
//                         disabled={isLoading}
//                       />
//                       <button
//                         type="button"
//                         className="toggle-password"
//                         onClick={() => setShowPassword(!showPassword)}
//                         tabIndex="-1"
//                       >
//                         {showPassword ? <FaEyeSlash /> : <FaEye />}
//                       </button>
//                     </div>
//                     {error && !error.includes('active orders') && !error.includes('active projects') && (
//                       <span className="error-message">{error}</span>
//                     )}
//                   </div>

//                   <button
//                     type="submit"
//                     className="btn-delete"
//                     disabled={isLoading || !password.trim()}
//                   >
//                     {isLoading ? (
//                       <>
//                         <FaSpinner className="spinner" />
//                         Processing...
//                       </>
//                     ) : (
//                       <>
//                         <FaTrash />
//                         Delete My Account
//                       </>
//                     )}
//                   </button>
//                 </form>
//               </div>
//             </div>

//             <div className="delete-card-footer">
//               <p>
//                 <span className="highlight">Need help?</span>{' '}
//                 <button className="link-button" onClick={() => navigate('/support')}>
//                   Contact Support
//                 </button>
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Confirmation Modal - Clean Version */}
//       {showConfirmDialog && (
//         <div className="modal-overlay" onClick={handleCancelDelete}>
//           <div className="modal-container" onClick={(e) => e.stopPropagation()}>
//             <button className="modal-close" onClick={handleCancelDelete}>
//               <FaTimes />
//             </button>
            
//             <div className="modal-header">
//               <div className="modal-icon danger">
//                 <FaExclamationTriangle />
//               </div>
//               <h2>Delete Account?</h2>
//               <p className="modal-subtitle">
//                 This action is permanent and cannot be undone.
//               </p>
//             </div>

//             <div className="modal-body">
//               <div className="consequences-list">
//                 <div className="consequence-item">
//                   <div className="consequence-icon">
//                     <FaUser />
//                   </div>
//                   <div className="consequence-content">
//                     <span className="consequence-label">Personal Information</span>
//                     <span className="consequence-desc">Will be anonymized</span>
//                   </div>
//                 </div>
//                 <div className="consequence-item">
//                   <div className="consequence-icon">
//                     <FaClock />
//                   </div>
//                   <div className="consequence-content">
//                     <span className="consequence-label">Transaction History</span>
//                     <span className="consequence-desc">Retained but anonymized</span>
//                   </div>
//                 </div>
//                 <div className="consequence-item">
//                   <div className="consequence-icon">
//                     <FaStar />
//                   </div>
//                   <div className="consequence-content">
//                     <span className="consequence-label">Reviews & Ratings</span>
//                     <span className="consequence-desc">Remain but anonymized</span>
//                   </div>
//                 </div>
//                 <div className="consequence-item">
//                   <div className="consequence-icon">
//                     <FaBan />
//                   </div>
//                   <div className="consequence-content">
//                     <span className="consequence-label">Account Access</span>
//                     <span className="consequence-desc">You will lose all access</span>
//                   </div>
//                 </div>
//                 <div className="consequence-item danger">
//                   <div className="consequence-icon">
//                     <FaExclamationTriangle />
//                   </div>
//                   <div className="consequence-content">
//                     <span className="consequence-label">Irreversible</span>
//                     <span className="consequence-desc">This action cannot be undone</span>
//                   </div>
//                 </div>
//               </div>

//               <div className="modal-confirm">
//                 <p className="confirm-label">
//                   Type <strong>DELETE</strong> to confirm
//                 </p>
//                 <div className="confirm-input-wrapper">
//                   <input
//                     type="text"
//                     placeholder="Type DELETE here"
//                     className={`confirm-input ${confirmText === 'DELETE' ? 'valid' : ''}`}
//                     value={confirmText}
//                     onChange={(e) => setConfirmText(e.target.value.toUpperCase())}
//                     autoFocus
//                   />
//                   {confirmText === 'DELETE' && (
//                     <div className="confirm-check">
//                       <FaCheckCircle />
//                     </div>
//                   )}
//                 </div>
//                 {confirmText && confirmText !== 'DELETE' && (
//                   <p className="confirm-error">
//                     Please type <strong>DELETE</strong> exactly
//                   </p>
//                 )}
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button 
//                 className="btn-cancel"
//                 onClick={handleCancelDelete}
//                 disabled={isLoading}
//               >
//                 Cancel
//               </button>
//               <button 
//                 className={`btn-delete-modal ${confirmText === 'DELETE' ? 'active' : ''}`}
//                 onClick={handleConfirmDelete}
//                 disabled={isLoading || confirmText !== 'DELETE'}
//               >
//                 {isLoading ? (
//                   <>
//                     <FaSpinner className="spinner" />
//                     Deleting...
//                   </>
//                 ) : (
//                   <>
//                     <FaTrash />
//                     Delete Account
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default DeleteAccount;



// src/pages/account/DeleteAccount.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { 
  FaArrowLeft, 
  FaTrash, 
  FaExclamationTriangle,
  FaEye,
  FaEyeSlash,
  FaSpinner,
  FaUser,
  FaShieldAlt,
  FaCheckCircle,
  FaTimes,
  FaStar,
  FaClock,
  FaBan,
  FaUserSlash,
  FaHistory,
  FaComment,
  FaLock
} from 'react-icons/fa';
import Nav from '../../../components/layout/Nav';
import { serverUrlAuth } from '../../../serverUrl';
import './DeleteAccount.scss';

const DeleteAccount = () => {
  const navigate = useNavigate();
  
  const [user, setUser] = useState(null);
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [error, setError] = useState('');
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);
  const [confirmText, setConfirmText] = useState('');
  const [confirmError, setConfirmError] = useState('');

  // Load user from localStorage on mount
  useEffect(() => {
    const token = localStorage.getItem('access_token');
    const role = localStorage.getItem('role');
    const fullName = localStorage.getItem('full_name');
    const email = localStorage.getItem('email');

    if (token && role) {
      setUser({
        role: role,
        full_name: fullName || '',
        email: email || '',
      });
    } else {
      navigate('/login');
    }
  }, [navigate]);

  // Check if user is admin and redirect
  useEffect(() => {
    if (user?.role === 'admin') {
      navigate('/admin-dashboard');
      toast.error('Administrator accounts cannot be deleted');
    }
  }, [user, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!password.trim()) {
      setError('Password is required');
      return;
    }

    setConfirmText('');
    setConfirmError('');
    setShowConfirmDialog(true);
  };

  const handleConfirmDelete = async () => {
    setIsLoading(true);
    setError('');

    try {
      const response = await serverUrlAuth.delete('users/delete-account/', {
        data: { password }
      });

      if (response.status === 200) {
        toast.success('Account deleted successfully');
        
        try {
          const token = localStorage.getItem('fcm_token');
          if (token) {
            await serverUrlAuth.post('/notifications/remove-push-token/', {
              token,
            });
          }
        } catch (fcmError) {
          console.error('Error removing FCM token:', fcmError);
        }

        localStorage.clear();
        navigate('/');
      }
    } catch (err) {
      const errorMessage = err.response?.data?.error || 'Failed to delete account';
      setError(errorMessage);
      toast.error(errorMessage);
      setShowConfirmDialog(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelDelete = () => {
    setShowConfirmDialog(false);
    setConfirmText('');
    setConfirmError('');
    setError('');
  };

  const handleBack = () => {
    navigate(-1);
  };

  // Close modal on Escape key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && showConfirmDialog) {
        handleCancelDelete();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [showConfirmDialog]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (showConfirmDialog) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showConfirmDialog]);

  if (!user) {
    return (
      <Nav>
        <div className="delete-account-page">
          <div className="container">
            <div className="loading-state">
              <FaSpinner className="spinner-large" />
              <p>Loading...</p>
            </div>
          </div>
        </div>
      </Nav>
    );
  }

  return (
    <>
      <Nav />
      <div className="delete-account-page">
        <div className="container">
          <button className="back-button" onClick={handleBack}>
            <FaArrowLeft />
            <span>Back to Profile</span>
          </button>

          <div className="delete-card">
            <div className="delete-card-header">
              <div className="icon-wrapper">
                <FaTrash />
              </div>
              <div>
                <h1>Delete Account</h1>
                <p>This action is permanent and cannot be undone</p>
              </div>
            </div>

            <div className="delete-card-body">
              <div className="alert alert-danger">
                <FaExclamationTriangle className="alert-icon" />
                <div>
                  <h4>Warning</h4>
                  <p>
                    Deleting your account will permanently remove all your personal information.
                    Your transaction history, reviews, and ratings will be anonymized but retained
                    for operational and compliance purposes.
                  </p>
                </div>
              </div>

              {error && (
                <div className="alert alert-error">
                  <FaExclamationTriangle className="alert-icon" />
                  <div>
                    <h4>Error</h4>
                    <p>{error}</p>
                  </div>
                </div>
              )}

              <div className="account-summary">
                <div className="summary-item">
                  <div className="summary-icon">
                    <FaUser />
                  </div>
                  <div>
                    <span className="label">Full Name</span>
                    <span className="value">{user?.full_name || 'N/A'}</span>
                  </div>
                </div>
                <div className="summary-item">
                  <div className="summary-icon">
                    <FaShieldAlt />
                  </div>
                  <div>
                    <span className="label">Role</span>
                    <span className="value role-badge">{user?.role || 'N/A'}</span>
                  </div>
                </div>
                <div className="summary-item">
                  <div className="summary-icon">
                    <FaCheckCircle />
                  </div>
                  <div>
                    <span className="label">Account Status</span>
                    <span className="value status-badge active">Active</span>
                  </div>
                </div>
              </div>

              <div className="delete-form-wrapper">
                <div className="form-header">
                  <h3>Confirm Your Identity</h3>
                  <p>Enter your current password to proceed with account deletion</p>
                </div>

                <form onSubmit={handleSubmit} className="delete-form">
                  <div className="form-group">
                    <label htmlFor="password">Current Password</label>
                    <div className={`password-input-wrapper ${isPasswordFocused ? 'focused' : ''} ${error ? 'error' : ''}`}>
                      <input
                        id="password"
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Enter your current password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onFocus={() => setIsPasswordFocused(true)}
                        onBlur={() => setIsPasswordFocused(false)}
                        disabled={isLoading}
                      />
                      <button
                        type="button"
                        className="toggle-password"
                        onClick={() => setShowPassword(!showPassword)}
                        tabIndex="-1"
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                    {error && !error.includes('active orders') && !error.includes('active projects') && (
                      <span className="error-message">{error}</span>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="btn-delete"
                    disabled={isLoading || !password.trim()}
                  >
                    {isLoading ? (
                      <>
                        <FaSpinner className="spinner" />
                        Processing...
                      </>
                    ) : (
                      <>
                        <FaTrash />
                        Delete My Account
                      </>
                    )}
                  </button>
                </form>
              </div>
            </div>

            <div className="delete-card-footer">
              <p>
                <span className="highlight">Need help?</span>{' '}
                <button className="link-button" onClick={() => navigate('/support')}>
                  Contact Support
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ======================================== */}
      {/* ✨ REDESIGNED MODAL - CLEAN & MODERN */}
      {/* ======================================== */}
      {showConfirmDialog && (
        <div className="modal-overlay" onClick={handleCancelDelete}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            {/* Close Button */}
            <button className="modal-close" onClick={handleCancelDelete}>
              <FaTimes />
            </button>

            {/* Modal Header */}
            <div className="modal-header">
              <div className="modal-icon">
                <FaExclamationTriangle />
              </div>
              <h2>Delete Account?</h2>
              <p className="modal-subtitle">
                This action is permanent and cannot be undone.
              </p>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              {/* Consequences List */}
              <div className="consequences-list">
                <div className="consequence-item">
                  <div className="consequence-icon">
                    <FaUserSlash />
                  </div>
                  <div className="consequence-content">
                    <span className="consequence-label">Personal Information</span>
                    <span className="consequence-desc">Will be permanently removed</span>
                  </div>
                </div>
                <div className="consequence-item">
                  <div className="consequence-icon">
                    <FaHistory />
                  </div>
                  <div className="consequence-content">
                    <span className="consequence-label">Transaction History</span>
                    <span className="consequence-desc">Retained but anonymized</span>
                  </div>
                </div>
                <div className="consequence-item">
                  <div className="consequence-icon">
                    <FaComment />
                  </div>
                  <div className="consequence-content">
                    <span className="consequence-label">Reviews & Ratings</span>
                    <span className="consequence-desc">Remain but anonymized</span>
                  </div>
                </div>
                <div className="consequence-item">
                  <div className="consequence-icon">
                    <FaLock />
                  </div>
                  <div className="consequence-content">
                    <span className="consequence-label">Account Access</span>
                    <span className="consequence-desc">You will lose all access</span>
                  </div>
                </div>
                <div className="consequence-item danger">
                  <div className="consequence-icon">
                    <FaExclamationTriangle />
                  </div>
                  <div className="consequence-content">
                    <span className="consequence-label">Irreversible</span>
                    <span className="consequence-desc">This action cannot be undone</span>
                  </div>
                </div>
              </div>

              {/* Confirmation Input */}
              <div className="modal-confirm">
                <p className="confirm-label">
                  Type <strong>DELETE</strong> to confirm
                </p>
                <div className="confirm-input-wrapper">
                  <input
                    type="text"
                    placeholder="Type DELETE here"
                    className={`confirm-input ${confirmText === 'DELETE' ? 'valid' : ''}`}
                    value={confirmText}
                    onChange={(e) => {
                      const value = e.target.value.toUpperCase();
                      setConfirmText(value);
                      if (value && value !== 'DELETE') {
                        setConfirmError('Please type DELETE exactly');
                      } else {
                        setConfirmError('');
                      }
                    }}
                    autoFocus
                  />
                  {confirmText === 'DELETE' && (
                    <div className="confirm-check">
                      <FaCheckCircle />
                    </div>
                  )}
                </div>
                {confirmError && (
                  <p className="confirm-error">{confirmError}</p>
                )}
              </div>
            </div>

            {/* Modal Footer */}
            <div className="modal-footer">
              <button 
                className="btn-cancel"
                onClick={handleCancelDelete}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button 
                className={`btn-delete-modal ${confirmText === 'DELETE' ? 'active' : ''}`}
                onClick={handleConfirmDelete}
                disabled={isLoading || confirmText !== 'DELETE'}
              >
                {isLoading ? (
                  <>
                    <FaSpinner className="spinner" />
                    Deleting...
                  </>
                ) : (
                  <>
                    <FaTrash />
                    Delete Account
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DeleteAccount;